<template>
  <div class="ABomTable">
    <ATable
      v-if="productionItems.length > 0"
      ref="table"
      class="no-pointer"
      rowKey="customKey"
      :data="productionItems"
      hide-top-panel
      hide-pagination
      hide-button-insert
    >
      <el-table-column type="index" label="No" :width="$width.index" />
      <el-table-column label="생산품명" prop="name" show-overflow-tooltip />
      <el-table-column
        label="규격"
        prop="size"
        width="100"
        show-overflow-tooltip
      />
      <el-table-column
        label="수량"
        prop="amount"
        class-name="cell-number cell-income"
        width="60"
      />
      <el-table-column label="단위" prop="unit_name" width="50" />
    </ATable>
    <ATable
      v-if="materialItems.length > 0"
      ref="table"
      class="no-pointer"
      rowKey="customKey"
      :data="materialItems"
      hide-top-panel
      hide-pagination
      hide-button-insert
    >
      <el-table-column type="index" label="No" :width="$width.index" />
      <el-table-column label="자재품명" prop="name" show-overflow-tooltip />
      <el-table-column
        label="규격"
        prop="size"
        width="100"
        show-overflow-tooltip
      />
      <el-table-column
        label="수량"
        prop="amount"
        class-name="cell-number cell-expense"
        width="60"
      />
      <el-table-column label="단위" prop="unit_name" width="50" />
    </ATable>
  </div>
</template>
<script>
export default {
  name: "ABomTable",
  props: {
    production: {
      type: Array,
      required: true,
    },
    material: {
      type: Array,
      required: true,
    },
  },
  computed: {
    productionItems() {
      return this.production;
    },
    materialItems() {
      return this.material;
    },
  },
};
</script>
